module.exports = __webpack_public_path__ + "static/media/tip_with_white_bg.1e5ae575.svg";